<div class="reset-password-container">
    <h2>{{ usernameFromParam ? 'Reset My Password' : 'Change My Password' }}</h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Username</mat-label>
      <input matInput type="text" formControlName="username" [readonly]="usernameFromParam !== ''">
      <mat-error *ngIf="form.get('username')?.hasError('required')">Username is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Current Password</mat-label>
      <input matInput type="password" formControlName="old_password" required>
      <mat-error *ngIf="form.get('old_password')?.hasError('required')">Current password is required</mat-error>
      <mat-error *ngIf="form.get('old_password')?.hasError('invalidOldPassword')">Current password is incorrect</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>New Password</mat-label>
      <input matInput type="password" formControlName="new_password" required>
      <mat-error *ngIf="form.get('new_password')?.hasError('required')">New password is required</mat-error>
      <mat-error *ngIf="form.get('new_password')?.hasError('minlength')">New password must be at least 8 characters</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Confirm New Password</mat-label>
      <input matInput type="password" formControlName="confirm_password" required>
      <mat-error *ngIf="form.get('confirm_password')?.hasError('required')">Please confirm your new password</mat-error>
      <mat-error *ngIf="form.get('confirm_password')?.hasError('passwordMismatch')">Passwords do not match</mat-error>
    </mat-form-field>

    <button mat-flat-button type="submit" [disabled]="form.invalid || isSaving">
      Reset Password
    </button>

  </form>
</div>
